import {
  ETicketEventDetailsUrl,
  ETicketLotteryDetailsUrl,
  ETicketMembershipDetailsUrl,
  Locales,
  TicketingFormCategory,
} from "@simplyk/common";

import { Translate } from "../../../../../common/hooks/useTranslate";

export const getStepETicketTranslations = (
  formCategory: TicketingFormCategory,
  t: Translate,
  isSweepstakes = false
): {
  title: string;
  description: string;
  switchLabel: string;
} => {
  if (isSweepstakes) {
    return {
      title: t("dashboard", "ticketing.setETicket.sweepstakes.title"),
      description: t("dashboard", "ticketing.setETicket.sweepstakes.description"),
      switchLabel: t("dashboard", "ticketing.setETicket.sweepstakes.switchLabel"),
    };
  }
  switch (formCategory) {
    case "Lottery":
      return {
        title: t("dashboard", "ticketing.setETicket.title"),
        description: t("dashboard", "ticketing.setETicket.lottery.description"),

        switchLabel: t("dashboard", "ticketing.setETicket.switchLabel"),
      };

    case "MembershipV2":
      return {
        title: t("dashboard", "ticketing.setETicket.membership.title"),
        description: t("dashboard", "ticketing.setETicket.membership.description"),
        switchLabel: t("dashboard", "ticketing.setETicket.membership.switchLabel"),
      };
    case "Custom":
      return {
        title: t("dashboard", "ticketing.setETicket.title"),
        description: t("dashboard", "ticketing.setETicket.custom.description"),
        switchLabel: t("dashboard", "ticketing.setETicket.switchLabel"),
      };
    default:
      return {
        title: t("dashboard", "ticketing.setETicket.title"),
        description: t("dashboard", "ticketing.setETicket.description"),
        switchLabel: t("dashboard", "ticketing.setETicket.switchLabel"),
      };
  }
};

export const getDetailsLink = (locale: Locales, formCategory: TicketingFormCategory) => {
  switch (formCategory) {
    case "Lottery":
      return ETicketLotteryDetailsUrl[locale];
    case "MembershipV2":
      return ETicketMembershipDetailsUrl[locale];
    default:
      return ETicketEventDetailsUrl[locale];
  }
};
